let _ = t => t,
  _t;
import { colors, rotate360 } from '@ovpn-ui/styles';
import styled from 'styled-components';
export const StyledSpinner = styled.div(_t || (_t = _`
    width: ${0}px;

    height: ${0}px;

    border: 2px solid ${0};

    border-bottom-color: ${0};

    border-radius: 50%;

    animation: ${0} 1s linear infinite;
`), ({
  $size
}) => $size, ({
  $size
}) => $size, colors.neutralBgHover, ({
  $color
}) => $color, rotate360(0));